import { browserHistory } from 'react-router';
import {
  all,
  call,
  delay,
  fork,
  put,
  select,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects';
import * as api from '../../services/order_management/api_order_management';
import * as apiCommon from '../../services/apiCommon';
import * as common from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';

export default function* (app) {
  try {
    yield all([
      fork(fetchListOrderManagementSaga, app),
      fork(deleteOrderManagementFromListSaga, app),
      fork(deleteOrderManagementSaga, app),
      fork(fetchOrderManagementForSaga, app),
      fork(saveOrderManagementSaga, app),
    ]);
  } catch (e) {
    console.error('@saga_order_management: ', e.message || e.stack);
    throw e;
  }
}

function* fetchListOrderManagementSaga(app) {
  yield takeLatest(
    'FETCH_LIST_ORDER_MANAGEMENT',
    callFetchListOrderManagement,
    app
  );
}

function* callFetchListOrderManagement(app, action) {
  const { filters, silent } = action;
  yield common.showProgressListTable(silent);
  try {
    const dataParams = {
      filters,
      list_type: 'order_management',
    };
    const tableData = yield call(apiCommon.getDocs, app, dataParams);
    yield call(common.doneListTable, {
      rows: tableData.data,
      total_rows: tableData.total,
    });
  } catch (error) {
    yield common.showErrorListTable(error);
  }
}

function* deleteOrderManagementFromListSaga(app) {
  yield takeEvery(
    'DELETE_ORDER_MANAGEMENT_FROM_LIST',
    callDeleteOrderManagementFromList,
    app
  );
}

function* callDeleteOrderManagementFromList(app, action) {
  yield deleteOrderManagement(app, action);
  yield delay(2000);
  yield callFetchListOrderManagement(app, { silent: true });
}

function* deleteOrderManagement(app, action) {
  yield put({ type: 'DELETE_RECORD_INPROGRESS' });
  try {
    const { id } = action;
    let result = null;
    if (id) {
      const state = yield select();
      const { tenant, user } = state;
      const { id } = action;
      const params = { tenant, user, id };
      result = yield call(api.deleteOrderManagement, app, params);
    }
    yield put({
      type: 'DELETE_RECORD_DONE',
      payload: { id, docType: DocType.ORDER_MANAGEMENT },
    });
    return result;
  } catch (error) {
    yield put({ type: 'DELETE_RECORD_ERROR', error });
  }
}

function* deleteOrderManagementSaga(app) {
  yield takeEvery(
    'DELETE_ORDER_MANAGEMENT',
    callDeleteOrderManagement,
    app
  );
}

function* callDeleteOrderManagement(app, action) {
  const result = yield deleteOrderManagement(app, action);
  yield delay(2000);
  if (result) {
    browserHistory.push('/admin/order_management/setup');
  }
}

function* fetchOrderManagementForSaga(app) {
  yield takeEvery(
    'FETCH_ORDER_MANAGEMENT',
    callFetchOrderManagement,
    app
  );
}

function* callFetchOrderManagement(app, action) {
  const { tenant, user } = yield select();
  const { id, silent } = action;
  try {
    if (id) {
      yield common.showProgressDataById(silent);
      const fetchParams = { tenant, user, id };
      const doc = yield call(
        api.fetchOrderManagement,
        app,
        fetchParams
      );
      yield common.doneDataById(doc);
    }
  } catch (error) {
    yield common.showErrorDataById(error);
  }
}

function* saveOrderManagementSaga(app) {
  yield takeEvery('SAVE_ORDER_MANAGEMENT', callSaveOrderManagement, app);
}

function* callSaveOrderManagement(app, action) {
  yield common.showProgressSaveRecord();
  const { tenant, user } = yield select();
  try {
    const result = yield call(api.saveOrderManagement, app, {
      tenant,
      user,
      data: action.data,
    });
    const id = result && result.id;
    yield callFetchOrderManagement(app, { id, silent: true });
    browserHistory.push(`/admin/order_management/setup/edit/${id}`);
    yield common.doneSaveRecord(result, 'Order management was saved');
  } catch (error) {
    yield common.showErrorSaveRecord(error);
  }
}
